// Packages
import PropTypes from 'prop-types'

// Components
import StockForm from 'modules/Stock/components/Form';

// Other
import useApi from 'hooks/useApi';

const StockEditScreen = ({  itemId, onClose, onSubmit }) => {

    const { data: item, put: updateItem, errors } = useApi('/stock/' + itemId);

	const submit = async (values) => {

        if( await updateItem(values, 'Stock updated!')) {

            onSubmit();
        }
    }

    return(
        <StockForm 
            errors={errors} 
            stock={item} 
            onClose={onClose} 
            onSubmit={submit} 
            type='edit' 
        />
    )
}

StockEditScreen.propTypes = {
    itemId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	onClose: PropTypes.func,
    onSubmit: PropTypes.func,
}

StockEditScreen.defaultProps = {
    itemId: null,
	onClose: () => {alert('onClose is not set!')},
    onSubmit: () => {alert('onSubmit is not set!')}
}

export default StockEditScreen;